// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"29a81857","12":"85dae842","32":"5bbfb8cc","158":"bfcb15f3","478":"85dae842","540":"85dae842","768":"560f2d8d","781":"85dae842","844":"9b97f600"}[chunkId] + ".css";
};